import { Props } from "./Models";

const HeaderView = ({
    title,
    goBack,
    hasLeftButton,
}: Props) => {
    return <header className="z-10 w-full bg-white h-[calc(72px)] text-black flex justify-around items-center">
        {hasLeftButton && <button onClick={goBack}>
            <img 
                src={process.env.PUBLIC_URL +"/arrow-left.png"}
                width={24}
                height={24}
                alt="voltar"
            />
        </button>}
        <h1 className="text-base">{title}</h1>
        {hasLeftButton && <span/>}
    </header>;
}

export default HeaderView;